import React from 'react'
import { Form, FormProps } from '@carsys/form'

import { FormikProps, isFunction } from 'formik'

export interface FormValues {
  UUID: string
  Name: string
  HasRemark: boolean
}

export const CaptureGMSForm: React.FC<
  {
    onSubmit: (v: FormValues) => void
    onSubmitSuccess: (v: FormValues) => void
    initialValues: FormValues
    children?: (formValues: FormikProps<FormValues>) => JSX.Element
  } & Omit<FormProps<FormValues, FormValues>, 'onSubmit' | 'onSubmitSuccess' | 'initialValues'>
> = ({ children, onSubmit, onSubmitSuccess, initialValues, ...rest }) => {
  const formSubmit = async (v: FormValues) => {
    onSubmit(v)
    return v
  }

  return (
    <Form
      initialValues={initialValues}
      NavigationConfirmation={null}
      validateOnChange={false}
      onSubmit={formSubmit}
      onSubmitSuccess={onSubmitSuccess}
      {...rest}
    >
      {formikProps => (isFunction(children) ? children(formikProps) : children)}
    </Form>
  )
}

export default CaptureGMSForm
